import {Component, Input} from '@angular/core';
import {AdService} from '@services/ad.service';
import {AlertService} from '@services/alert.service';
import {LEAD_DEFAULT_STATUS, PublisherLead} from '@models/favorite';

// Sélecteur de statut d'un lead (statuts renvoyés par l'API), enregistré à chaque changement
@Component({
    selector: 'app-lead-status',
    templateUrl: './lead-status.component.html',
    styleUrls: ['./lead-status.component.scss']
})
export class LeadStatusComponent {

    @Input() lead: PublisherLead;
    @Input() statuses: string[] = [];
    saving = false;

    get value(): string {
        return this.lead && this.lead.status ? this.lead.status : LEAD_DEFAULT_STATUS;
    }

    // Le statut courant reste sélectionnable même s'il n'est plus dans la liste
    get options(): string[] {
        const list = this.statuses && this.statuses.length ? this.statuses : [LEAD_DEFAULT_STATUS];
        return list.includes(this.value) ? list : [this.value].concat(list);
    }

    constructor(private adService: AdService, private alertService: AlertService) {
    }

    change(status: string) {
        const previous = this.lead.status;
        this.lead.status = status;
        this.saving = true;
        this.adService.updateLeadStatus(this.lead.id, status).subscribe(updated => {
            this.saving = false;
            if (updated && updated.status) {
                this.lead.status = updated.status;
            }
        }, error => {
            this.saving = false;
            this.lead.status = previous;
            this.alertService.error(typeof error === 'string' ? error : 'La mise à jour du statut a échoué.');
        });
    }
}
